// extracted by mini-css-extract-plugin
export default {"cardHolder":"TextCardWrapper_cardHolder__MbdJy","boxHolder":"TextCardWrapper_boxHolder__9WlJ2","rotate":"TextCardWrapper_rotate__H17-s"};